
import { Component, Inject, OnInit } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material';
import { Quote } from '../../../models/quote.model';
import { AlertService } from '../../../services/alert.service';
import * as _ from 'lodash';
import { CreateEditQuoteModalComponent } from '../create-edit-quote-modal/create-edit-quote-modal.component';

@Component({
    selector: 'view-quote-modal',
    template: require('./view-quote-modal.component.html'),
    styles: [require('./view-quote-modal.component.css')]
})
export class ViewQuoteModalComponent implements OnInit {
    currentQuote;

    public _ = _;

    constructor(private alertService: AlertService, private apiService: ApiService,
        private dialog: MatDialog,
        public dialogRef: MatDialogRef<ViewQuoteModalComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
        this.currentQuote = data.currentQuote;
    }

    ngOnInit() {

    }


    ok() {
       
    }

    editQuote() {
        this.dialogRef.close();
            let dialogRef = this.dialog.open(CreateEditQuoteModalComponent, {
                panelClass: "col-md-12",
                data: {
                    currentQuote: this.currentQuote,
                    //vendors: this.Services
                }
            });

            dialogRef.afterClosed().subscribe(r => {
                if (r) {
                    //this.getQuotes();
                }
            })

    }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/quote-home/view-quote-modal/view-quote-modal.component.ts